import { z } from 'zod';
import { SessionKindSchema } from './grades';

/**
 * « Demande de vérification de note »: a student questions an ECUE mark of a published session. The teacher
 * of the sheet (or the registrar) answers: mark maintained, or corrected — the change itself still goes
 * through the grid (draft sheet) or a correction request (locked sheet).
 */
export const GRADE_REVIEW_STATUSES = ['pending', 'maintained', 'corrected'] as const;
export type GradeReviewStatus = (typeof GRADE_REVIEW_STATUSES)[number];

export const GradeReviewInputSchema = z.object({
  enrollmentId: z.uuid(),
  courseId: z.uuid(),
  session: SessionKindSchema,
  message: z.string().trim().min(10, 'gradeReviews.errors.message').max(1000),
});
export type GradeReviewInput = z.infer<typeof GradeReviewInputSchema>;

export const GradeReviewAnswerSchema = z.object({
  outcome: z.enum(['maintained', 'corrected']),
  response: z.string().trim().min(3, 'gradeReviews.errors.response').max(1000),
});
export type GradeReviewAnswer = z.infer<typeof GradeReviewAnswerSchema>;

export const GradeReviewSchema = z.object({
  id: z.uuid(),
  gradeSheetId: z.uuid(),
  studentId: z.uuid(),
  matricule: z.string(),
  studentName: z.string(),
  courseId: z.uuid(),
  courseName: z.string(),
  levelCode: z.string(),
  groupName: z.string(),
  session: SessionKindSchema,
  semesterIndex: z.number().int(),
  teacherName: z.string().nullable(),
  message: z.string(),
  status: z.enum(GRADE_REVIEW_STATUSES),
  response: z.string().nullable(),
  answeredByName: z.string().nullable(),
  createdAt: z.string(),
  answeredAt: z.string().nullable(),
});
export type GradeReview = z.infer<typeof GradeReviewSchema>;

export const GradeReviewListQuerySchema = z.object({
  yearId: z.uuid().optional(),
  status: z.enum(GRADE_REVIEW_STATUSES).optional(),
  gradeSheetId: z.uuid().optional(),
});
export type GradeReviewListQuery = z.infer<typeof GradeReviewListQuerySchema>;

/** What the student app needs to offer the request: open window and the courses already asked about. */
export const MyGradeReviewsSchema = z.object({
  items: z.array(GradeReviewSchema),
  /** 0 = the school does not take requests. */
  windowDays: z.number().int(),
});
export type MyGradeReviews = z.infer<typeof MyGradeReviewsSchema>;
